// Category colors for the printed top sheet. Paper is never themed, so these stay fixed
// in every appearance preset and mode; they follow the same hue order as the on-screen
// palette in `../budgetCategoryPalette.ts` (blue, violet, emerald, red-orange, blue).

const PRINT_CATEGORY_HEXES = ["#2f80ed", "#9b51e0", "#27ae60", "#ff471a", "#2f80ed"] as const;

const PRINT_BAND_ALPHA = 0.48;

const hexToRgb = (hex: string): { r: number; g: number; b: number } => {
  const value = hex.replace("#", "");
  return {
    r: parseInt(value.slice(0, 2), 16),
    g: parseInt(value.slice(2, 4), 16),
    b: parseInt(value.slice(4, 6), 16),
  };
};

/** The translucent band color for one printed category row, as `rgba(...)`. */
export const getBudgetPrintBandColor = (index: number): string => {
  const hex =
    PRINT_CATEGORY_HEXES[
      ((index % PRINT_CATEGORY_HEXES.length) + PRINT_CATEGORY_HEXES.length) %
        PRINT_CATEGORY_HEXES.length
    ];
  const { r, g, b } = hexToRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${PRINT_BAND_ALPHA})`;
};
